import React from 'react';
import {useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities'

const EmailItem = (props) =>{

    const item = props.item;
    const signIndex = props.signIndex;
    const handleDelete = props.handleDelete;
    const forceOrder = props.forceOrder;

    const {
        setNodeRef,
        attributes,
        listeners,
        transition,
        transform
    } = useSortable({id:item.email})

    const style = {
        transition,
        transform: CSS.Transform.toString(transform)
    }

    return (
        <div className={"email-tag-item"}>
        <div
            className={"email-item"} 
            ref = {setNodeRef}
            style = {style}
            key = {item.email}
            {...attributes}
            {...listeners}
        > 
         <div>{forceOrder?signIndex+ ". " +item.email:item.email}</div>
        </div>        

          <button
            type="button"
            className="button" 
            onClick={() => handleDelete(item)}
          >
            &times; 
          </button> 
        </div>
    )        
}

export default EmailItem;